module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('div', {
    staticClass: "error-wrap"
  }, [_c('div', {
    staticClass: "disable-device-wrap"
  }, _vm._l((_vm.disableDevices), function(dev) {
    return _c('div', {
      staticClass: "disable-device"
    }, [_c('p', [_vm._v("藥盒位置：" + _vm._s(dev.net.open_times) + " - " + _vm._s(dev.net.row_id) + " - " + _vm._s(dev.pos_row) + " - " + _vm._s(dev.relative_col))])])
  }), 0), _vm._m(0)])]), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hint-msg"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("已鎖定藥盒清單。請將此畫面拍下，並與工程人員聯絡，謝謝！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e65bd91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DisableDevicesList.vue
// module id = 1485
// module chunks = 1